const tag = '[UI]';

export class ToggleSidenavCollapsed {
  static readonly type = `${tag} toggle sidenav collapsed`;
}

export class SetSidenavCollapsed {
  static readonly type = `${tag} set sidenav collapsed`;
  constructor(public collapsed: boolean) {}
}

export class SetSidenavHovered {
  static readonly type = `${tag} set sidenav hovered`;
  constructor(public hovered: boolean) {}
}

export class IsCreationProcess {
  static readonly type = `${tag} show main container padding`;
  constructor(public show: boolean) {}
}
